import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc, collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from '../../firebaseConfig'
import styles from '../../css/terms.module.css';

const Terms = () => {
    const location = useLocation();

    const [target, setTarget] = useState(0);
    const [detailData, setDetailData] = useState();
    const [termsDataList, setTermsDataList] = useState();

    const termsCollectionRef = collection(db, "terms");
    const getTerms = async (num = 0) => {
        setTarget(num);
        const q = query(termsCollectionRef, orderBy("title", "desc"))
        const data = await getDocs(q);
        const termsData = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        setDetailData(termsData[num])
        setTermsDataList(termsData.map((doc) => doc.title))
    }
    useEffect(() => {
        getTerms();
    }, [])

    const handleSelect = (e) => {
        setTarget(e.target.value);
        getTerms(e.target.value);
    };

    // 테이블 가로스크롤 + 조항 제목에 hash id 부여
    // Toast UI는 저장 시 id 속성을 보존하지 않으므로, 렌더 후 "제 N조" 텍스트로 id를 붙입니다.
    useEffect(() => {
        if (!detailData) return;
        const root = document.querySelector(`#main_container`);
        if (!root) return;

        root.querySelectorAll('table').forEach((table) => {
            if (table.parentElement?.classList.contains(styles.table_scroll)) return;
            const wrap = document.createElement('div');
            wrap.className = styles.table_scroll;
            table.replaceWith(wrap);
            wrap.appendChild(table);
        });

        root.querySelectorAll('h1, h2, h3, h4, h5, h6, p').forEach((el) => {
            if (el.closest('table')) return;
            const match = el.textContent?.trim().match(/^제\s*(\d+)\s*조/);
            if (match) el.id = `section${match[1]}`;
        });
    }, [detailData]);

    const ContainerPointBtn = ({ iconClass, caption, href }) => {
        return (
            <div className={styles.btn_item}>
                <a href={href}><i className={`${styles.btn_item_icon} ${iconClass}`}></i></a>
                <p>{caption}</p>
            </div>
        )
    }
    return (
        <>
            {detailData &&
                <section className={styles.terms}>
                    <div className="wrp">
                        <main>
                            <div className={styles.terms_header}>
                                <h3>개인정보 처리방침</h3>
                                {termsDataList && (
                                    <div className={styles.select_terms}>
                                        <select onChange={handleSelect} value={target}>
                                            {termsDataList.map((item, index) => (
                                                <option key={index} value={index}>{item}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                            <div className={styles.container} >
                                <p>주식회사 핀테크(이하"회사"또는 "핀테크")는 이용자의 신용정보를 포함한 개인정보(이하"개인(신용)정보"라함)를 매우 소중히 생각합니다 회사는 신용정보의 이용 및 보호에 관한 법률, 개인정보 보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련 법령을 준수하여 개인(신용)정보를 적법하게 처리하고 안전하게 관리하고 있습니다. 이에 개인정보 보호법 제 30조에 따라 이용자에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련된 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립,공개합니다.</p>
                            </div>
                            <div className={styles.btn_wrapper}>
                                <ContainerPointBtn iconClass={styles.icon_termsbtn_01} caption="처리목적" href="#section1" />
                                <ContainerPointBtn iconClass={styles.icon_termsbtn_02} caption="처리항목" href="#section2" />
                                <ContainerPointBtn iconClass={styles.icon_termsbtn_03} caption="보유기간" href="#section3" />
                                <ContainerPointBtn iconClass={styles.icon_termsbtn_04} caption="제3자 제공" href="#section4" />
                                <ContainerPointBtn iconClass={styles.icon_termsbtn_05} caption="처리위탁" href="#section5" />
                                <ContainerPointBtn iconClass={styles.icon_termsbtn_06} caption="고충처리 부서" href="#section10" />
                            </div>
                            <div className={styles.container} id="main_container">
                                <article dangerouslySetInnerHTML={{ __html: detailData.content }}>
                                    { }
                                </article>
                            </div>
                            <div className={styles.container} >
                                <p className="mt60 pb100"><i className={styles.icon_logo}></i></p>
                            </div>
                        </main>
                    </div>
                </section>
            }

        </>
    );

};

export default Terms;